import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './AiAssessUpsellModal.css';



const STEPS = [
  'Pick a product',
  'Run the AI PCF agent',
  'Review & approve the result',
];

/**
 * Upsell modal shown to free-plan users when they click "AI Assess".
 * Presentational — controlled by `show` / `onClose`. The primary CTA routes
 * to the billing page so users can upgrade to a paid plan.
 */
export default function AiAssessUpsellModal({ show, onClose }) {
  const navigate = useNavigate();

  // Lock body scroll while open
  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [show]);

  if (!show) return null;

  const handleUpgrade = () => {
    onClose && onClose();
    navigate('/billing');
  };

  return (
    <>
      <div
        className="modal fade show ai-assess-modal"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        style={{ display: 'block' }}
        onClick={onClose}
      >
        <div
          className="modal-dialog modal-dialog-centered ai-assess-modal__dialog"
          role="document"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-content ai-assess-modal__content">
            <button
              type="button"
              className="btn-close ai-assess-modal__close"
              onClick={onClose}
              aria-label="Close"
            />

            {/* Hero */}
            <div className="ai-assess-modal__hero">
              <span className="ai-assess-modal__badge">✨ AI Product Footprint Assessment</span>
              <h4 className="ai-assess-modal__title">
                Get an instant product footprint
              </h4>
              <p className="ai-assess-modal__subtitle">
                Stop assessing by hand. Zilch's AI PCF Agent delivers audit-ready Product Carbon Footprints in seconds — unlimited agent usage on paid plans <Link className='billing_link' to="/billing">view pricing here</Link>.
              </p>
            </div>

            <div className="modal-body ai-assess-modal__body">
              
              

              {/* How it works */}
              <div className="ai-assess-modal__steps">
                <p className="ai-assess-modal__steps-label">As easy as 1-2-3</p>
                <div className="ai-assess-modal__steps-row">
                  {STEPS.map((step, i) => (
                    <div className="ai-assess-modal__step" key={step}>
                      <span className="ai-assess-modal__step-num">{i + 1}</span>
                      <span className="ai-assess-modal__step-text">{step}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="ai-assess-modal__footer">
              <button
                type="button"
                className="btn ai-assess-modal__cta-secondary"
                onClick={onClose}
              >
                Maybe later
              </button>
              <button
                type="button"
                className="btn ai-assess-modal__cta-primary"
                onClick={handleUpgrade}
              >
                See pricing & upgrade
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show ai-assess-modal__backdrop" />
    </>
  );
}
